import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Pagination, SortableHeader, Table, TableColumnsMenu, nextSort, tableColumnsStorageKey, useTableColumns, } from '@wit-support/ui';
const PAGE_SIZES = [10, 25, 50];
export function LiveTable({ tableId, columns, rows, rowKey, defaultSort, empty, pageSize: initialPageSize = 10, caption, showSettings = true, }) {
    const defs = useMemo(() => columns.map((c) => c.def), [columns]);
    const cols = useTableColumns(tableColumnsStorageKey('ads-campaigns', tableId), defs);
    const [sort, setSort] = useState(defaultSort);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(initialPageSize);
    const byId = useMemo(() => new Map(columns.map((c) => [c.def.id, c])), [columns]);
    const sorted = useMemo(() => {
        const col = byId.get(sort.key);
        if (!col)
            return [...rows];
        const dir = sort.dir === 'asc' ? 1 : -1;
        return [...rows].sort((a, b) => {
            const x = col.sortValue(a);
            const y = col.sortValue(b);
            if (x === null && y === null)
                return 0;
            if (x === null)
                return 1;
            if (y === null)
                return -1;
            if (typeof x === 'number' && typeof y === 'number')
                return (x - y) * dir;
            return String(x).localeCompare(String(y), 'ru') * dir;
        });
    }, [rows, sort, byId]);
    const pages = Math.max(1, Math.ceil(sorted.length / pageSize));
    const cur = Math.min(page, pages);
    const slice = sorted.slice((cur - 1) * pageSize, cur * pageSize);
    return (_jsxs("div", { className: "flex flex-col gap-2", "data-testid": `live-table-${tableId}`, children: [showSettings ? (_jsx("div", { className: "flex justify-end", children: _jsx(TableColumnsMenu, { columns: cols, label: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0442\u0430\u0431\u043B\u0438\u0446\u044B", sort: sort }) })) : null, _jsx("div", { className: "overflow-x-auto rounded-md border border-[var(--color-border-default)]", children: _jsxs(Table, { density: "compact", children: [caption ? _jsx(Table.Caption, { className: "sr-only", children: caption }) : null, _jsx(Table.Header, { children: _jsx(Table.Row, { className: "hover:bg-transparent", children: cols.visible.map((col) => {
                                    const c = byId.get(col.id);
                                    if (!c)
                                        return null;
                                    return (_jsx(SortableHeader, { column: col, sortKey: col.id, sort: sort, onSortChange: (s) => {
                                            setSort(nextSort(sort, s.key, c.align === 'right' ? 'desc' : 'asc'));
                                            setPage(1);
                                        }, align: c.align ?? 'left', indicator: "end", className: "px-2 whitespace-nowrap", children: c.header }, col.id));
                                }) }) }), _jsx(Table.Body, { children: slice.length === 0 ? (_jsx(Table.Empty, { colSpan: Math.max(1, cols.visible.length), children: empty ?? 'Пусто' })) : (slice.map((row) => (_jsx(Table.Row, { children: cols.visible.map((col) => {
                                    const c = byId.get(col.id);
                                    if (!c)
                                        return null;
                                    return (_jsx(Table.Cell, { column: col, className: c.align === 'right' ? 'px-2 text-right tabular-nums' : 'px-2', children: c.cell(row) }, col.id));
                                }) }, rowKey(row))))) })] }) }), sorted.length > pageSize || pageSize !== initialPageSize ? (_jsx(Pagination, { page: cur, pageSize: pageSize, pageSizeOptions: PAGE_SIZES, total: sorted.length, onPageChange: setPage, onPageSizeChange: (s) => {
                    setPageSize(s);
                    setPage(1);
                } })) : null] }));
}
//# sourceMappingURL=live-table.js.map